export default __webpack_public_path__ + "static/media/icon_italic.2636632d.svg";